"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createId = createId;
exports.createIdUnordered = createIdUnordered;
const sha256 = require("crypto-js/sha256");
const sort_1 = require("./sort");
/**
 * ! WARNING:
 * ! Changing the underlying implementation of these methods will break determinism for the users!
 * ! This could create extremely confusing runtime bugs
 * ! If changes need to be made, they must be introduced with new methods (e.g. createIdV2), allowing the user to choose
 */
/**
 * Creates a deterministic ID
 * The order of the inputs changes the output
 * @param strings
 * @returns a deterministic ID
 */
function createId(...strings) {
    return sha256(strings.join('')).toString();
}
/**
 * Creates a deterministic ID
 * The order of the inputs does not change the output
 * @param strings
 */
function createIdUnordered(...strings) {
    const sortedInputs = (0, sort_1.sort)(strings);
    return createId(...sortedInputs);
}
